import Phone from "assets/images/PhoneOtp.png";
import BftButton from "common/components/button";

import { FormEvent, useState } from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useSelector } from "react-redux";

interface Props {
	show: boolean;
	message: any;
	handleClose: () => void;
	onResend: () => void;
	onSubmit: (opt: string) => void;

	type?: "email" | "sms";
}

const OtpModal: React.FC<Props> = (props) => {
	const { show, message, type = "email", handleClose, onResend, onSubmit } = props;

	const authorization = useSelector((state: any) => state.authorization);

	const [otp, setOtp] = useState("");

	const handleSubmit = (e: FormEvent) => {
		e.preventDefault();

		onSubmit(otp);
	};

	return (
		<Modal show={show} backdrop="static" onHide={handleClose} keyboard={false}>
			<Modal.Header closeButton>
				{type === "email" && (
					<div className="d-flex align-items-center flex-column">
						<h5>Codice di verifica {type}</h5>
					</div>
				)}
			</Modal.Header>
			<div
				className="d-flex align-items-center flex-column"
				style={{
					borderRadius: "100%",
					borderTopLeftRadius: "0%",
					borderTopRightRadius: "0%",
					borderStyle: "solid",
					backgroundColor: "#EBF4FE",
					border: "0px",
					width: "auto",
					height: "auto",
				}}
			>
				{type === "sms" && <img src={Phone} className="w-25 p-3 pb-0"></img>}
			</div>
			{type === "sms" && (
				<div className="d-flex align-items-center flex-column mt-3">
					<h5>Codice di conferma {type}</h5>
				</div>
			)}

			<form onSubmit={handleSubmit}>
				<Modal.Body>
					{message}

					<OtpInput
						containerStyle={{ justifyContent: "center", marginTop: "1rem" }}
						inputStyle={{ width: "1.7rem" }}
						inputType="number"
						value={otp}
						onChange={setOtp}
						numInputs={6}
						shouldAutoFocus={true}
						renderSeparator={<span className="mx-lg-3 m-2">-</span>}
						renderInput={(props) => <input {...props} />}
					/>
					<div className="text-danger mt-3">{authorization?.error?.message}</div>
				</Modal.Body>

				<Modal.Footer className="justify-content-center">
					<span className="gray">Non hai ricevuto il codice?</span>

					<BftButton type="button" className="btn-link ml-auto" onClick={() => onResend()}>
						Invia di nuovo
					</BftButton>

					<BftButton
						type="submit"
						className="btn-buffetti col-12 ml-auto"
						isDisabled={otp.length < 6}
					>
						Conferma
					</BftButton>
				</Modal.Footer>
			</form>
		</Modal>
	);
};
export default OtpModal;
